module.exports = __webpack_public_path__ + "static/media/pdf.1148605e.svg";